import { Box, Slide } from "@mui/material";
import { FC } from "react";
import { useDialogData } from "../context/DialogProvider";

const DialogCharacter: FC = () => {
  console.info("DialogsCharacter render");
  const { currentCharacter } = useDialogData();

  return (
    <Slide
      direction="right"
      in={currentCharacter !== ""}
      timeout={500}
      appear
      unmountOnExit
    >
      <Box
        component={"img"}
        src={currentCharacter}
        sx={{
          position: "absolute",
          bottom: "-270px",
          left: { xl: "2em", sm: "-1em", lg: "-1em" },
          maxHeight: "100vh",
        }}
      ></Box>
    </Slide>
  );
};

export default DialogCharacter;
